var _excluded = ["listings", "maxColumns"],
  _excluded2 = ["slideType"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import ListingModel from './models/listing';
import HomePageSlide from './variants/home-page';
import BrowsePage from './variants/browse-page';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesPropertyOfTheWeek = _ref => {
  var allListings = _ref.listings,
    maxColumns = _ref.maxColumns,
    props = _objectWithoutProperties(_ref, _excluded);
  var slideType = props.slideType,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var listings = allListings.slice(0, maxColumns);
  switch (slideType) {
    case 'browse':
      return ___EmotionJSX(BrowsePage, _extends({
        listings: listings
      }, otherProps));
    case 'home':
    default:
      return ___EmotionJSX(HomePageSlide, _extends({
        listings: listings
      }, otherProps));
  }
};
AllhomesPropertyOfTheWeek.propTypes = {
  slideType: PropTypes.oneOf(['home', 'browse']),
  listings: PropTypes.arrayOf(PropTypes.shape(ListingModel)).isRequired,
  maxColumns: PropTypes.number,
  onClick: PropTypes.func,
  title: PropTypes.string
};
AllhomesPropertyOfTheWeek.defaultProps = {
  slideType: 'home',
  maxColumns: 3,
  onClick: () => {},
  title: 'Property of the Week'
};
export default AllhomesPropertyOfTheWeek;